import React from 'react';
import {
  ClipboardList,
  Files,
  Calculator,
  FileSpreadsheet,
  Compass,
  HardHat,
  ShoppingCart,
  Users,
} from 'lucide-react';

const iconMap = {
  ClipboardList,
  Files,
  Calculator,
  FileSpreadsheet,
  Compass,
  HardHat,
  ShoppingCart,
  Users,
};

const ServiceCard = ({ service, isLastCol, isLastRow }) => {
  const Icon = iconMap[service.icon];
  return (
    <div
      className={`service-card ${isLastCol ? 'lg:border-r-0' : ''} ${
        isLastRow ? 'lg:border-b-0' : ''
      }`}
    >
      <div className="flex items-start justify-between mb-10">
        <div className="w-9 h-9 flex items-center justify-center text-[#a4514a]">
          {Icon && <Icon size={22} strokeWidth={1.4} />}
        </div>
        <span className="label-caps text-[#a89f92]">{service.num}</span>
      </div>
      <h3 className="font-serif text-[#201d1a] text-[24px] leading-[1.15] mb-4">
        {service.title}
      </h3>
      <p className="text-[14.5px] leading-[1.7] text-[#5b524a] flex-1">
        {service.description}
      </p>
      {service.tag && (
        <div className="mt-6">
          <span className="label-caps text-[#a4514a] border border-[#d6b8b4] px-2.5 py-1 inline-block">
            {service.tag}
          </span>
        </div>
      )}
    </div>
  );
};

export default ServiceCard;
